/**
 * Profile Service for Portal
 *
 * Handles fetching and updating contact profile information
 */

import { investorPortalApiClient } from '../../shared/utils/api-client';

import type { InvestorPortalRole, PortalModule } from '@/types/investor';

/**
 * Contact information interface
 */
export interface ContactInfo {
  id: string; // UUID serialized as string from API
  first_name: string | null;
  last_name: string | null;
  email: string;
  phone: string | null;
  mobile: string | null;
  role: string | null;
  title: string | null;
  department: string | null;
  receives_reports: boolean;
  receives_capital_calls: boolean;
  receives_distributions: boolean;
  portal_role: InvestorPortalRole;
  accessible_modules: PortalModule[];
}

/**
 * Investor information interface
 */
interface InvestorInfo {
  id: string; // UUID serialized as string from API
  name: string;
  investor_type: string;
  is_individual: boolean;
  country: string | null;
  telephone_number: string | null;
}

/**
 * Profile response interface
 */
export interface ProfileData {
  contact: ContactInfo;
  investor: InvestorInfo;
}

/**
 * Contact update request interface
 */
export interface ContactUpdateRequest {
  first_name?: string | null;
  last_name?: string | null;
  phone?: string | null;
  mobile?: string | null;
  title?: string | null;
  department?: string | null;
  receives_reports?: boolean;
  receives_capital_calls?: boolean;
  receives_distributions?: boolean;
}

export class ProfileService {
  /**
   * Get current user's profile
   */
  static async getProfile(): Promise<ProfileData> {
    return investorPortalApiClient.get<ProfileData>('/portal/profile');
  }

  /**
   * Update current user's contact information
   */
  static async updateProfile(data: ContactUpdateRequest): Promise<ProfileData> {
    return investorPortalApiClient.put<ProfileData>('/portal/profile', data);
  }
}
